<template>
  <div class="reset-password">
    <p :class="`${dense ? 'mb-1': 'mb-4'}`" style="font-size: 1.75em;">
      Passwort vergessen
    </p>

    <v-form @submit.prevent="" id="forgotPwdForm" v-if="!sent" v-model="valid">
      <fin-email-input id="mail"
                       v-model="form.fields.email"
                       :disabled="disabled"
                       :errorMessages="form.errors.errorEmail"
      />
      <v-btn v-if="form.errors.errorEmailCode === 'UserNotConfirmedException' && isActive"
             id="sendActivationCode"
             :disabled="!isActive"
             color="fin-color-primary-dark"
             text
             @click="resendVerificationCode">
        Verifikation erneut zusenden
      </v-btn>
      <div class="d-flex setPwBtn">
        <v-btn :disabled="disabled || !valid" :loading="loading"
               v-if="form.errors.errorEmailCode !== 'UserNotConfirmedException' || !isActive"
               @click="submit" color="fin-color-primary-dark" outlined
               id="submitMailBtn"
               type="submit">
          Absenden
        </v-btn>
        <v-btn id="cancelBtn"
               color="fin-color-primary-dark"
               text
               @click="$emit('abort')">
          Abbrechen
        </v-btn>
      </div>

      <fin-info-msg v-if="!isActive" :msg="info" class="mt-5"/>
      <p v-if="!isActive" style="text-align: center">
        Nichts angekommen? Überprüfe auch deinen Spam-Ordner.
      </p>
    </v-form>

    <div v-else>
      In Kürze solltest du auf {{ form.email }} eine E-Mail mit einem Link zum Zurücksetzen deines Passworts erhalten.
      <v-img :height="125"
             :src="require('@/assets/onboarding/registration/email-confirmation-successful.svg')" :width="225"
             class="my-10"
             contain style="margin: 0 auto;"/>
    </div>
  </div>
</template>

<script>
import finEmailInput from '@/components/common/form/EmailInput'
import FinInfoMsg from "@/components/common/InfoMsg"

export default {
  name: 'FinForgotPassword',
  components: {
    FinInfoMsg,
    finEmailInput
  },
  props: {
    dense: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      sent: false,
      loading: false,
      error: '',
      valid: true,
      isActive: true,
      form: {
        fields: {
          email: '',
        },
        errors: {
          errorEmail: '',
          errorEmailCode: null
        }
      },
      disabled: process.env.VUE_APP_ALLOW_PASSWORD_RESET !== 'true',
      info: ''
    }
  },
  methods: {
    submit() {
      if (this.disabled || !this.valid) {
        // should not happen, but protect this case
        return
      }

      this.loading = true
      let email = this.form.fields.email

      //remove whitespaces accidentally entered by a user
      email = email.trim()

      this.$Amplify.Auth.forgotPassword(
        email,
        {
          preferredLang: 'de_DE',
          signUpHost: window.location.origin
        }
      ).then(data => {
        this.loading = false
        console.log('TODO track', data)
        this.form.errors.errorEmail = ''
        this.form.errors.errorEmailCode = ''
        this.sent = true
      }).catch(err => {
        this.loading = false
        console.error('forgotPassword failed', err)
        this.form.errors.errorEmail = ''

        // reference: https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_ForgotPassword.html
        if (['UserNotConfirmedException'].includes(err.code)) {
          this.form.errors.errorEmail = 'Die E-Mail-Adresse wurde noch nicht aktiviert.'
          this.form.errors.errorEmailCode = 'UserNotConfirmedException'
        } else if (['UserNotFoundException'].includes(err.code)) {
          this.form.errors.errorEmail = 'Unbekannte E-Mail-Adresse.'
        } else if (['Cannot reset password for the user as there is no registered/verified email or phone_number'].includes(err.message)) {
          this.form.errors.errorEmail = 'Die E-Mail-Adresse wurde noch nicht aktiviert.'
          this.form.errors.errorEmailCode = 'UserNotConfirmedException'
        } else if (['LimitExceededException'].includes(err.code)) {
          this.form.errors.errorEmail = 'Das Versuchslimit wurde überschritten. Bitte versuche es nach einiger Zeit erneut.'
        } else {
          this.form.errors.errorEmail = 'Fehler beim Senden der E-Mail, wende dich bitte an den Support.'
        }
      })
    },
    resendVerificationCode() {
      if (this.form.fields.email && this.form.fields.email.length > 0 && this.form.fields.email !== 'test@test.de') {
        this.$Amplify.Auth.resendSignUp(this.form.fields.email, {
          preferredLang: 'de_DE',
          signUpHost: window.location.origin
        }).then(() => {
          this.info = 'Ein neuer Verifikations-Code wurde dir zugeschickt.'
          this.isActive = false
          this.form.errors.errorEmail = ''
          this.form.errors.errorEmailCode = ''
        }).catch(this.setError)
      }
    }
  }
}
</script>

<style scoped>
  @media only screen and (max-width: 350px) {
    .setPwBtn{
      flex-direction: column;
    }
  }
</style>
